<template>
	<div id="AppPage">
		<SideBar />
		<div class="app-body">
			<AppHeader :user="user" :currentProperty="property" @search="handleSearch" />
			<div class="app-content">
				<router-view :currentProperty="property" :user="user" :search-query="searchQuery"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import jwtService from '../services/jwtService';
import SideBar from "@/layout/SideBar.vue";
import AppHeader from "@/layout/AppHeader.vue";

export default {
	name: "AppPage",
	components: {
		SideBar,
		AppHeader,
	},
	data() {
		return {
			property: {},
			user: {},
			searchQuery: "",
		};
	},
	created() {
		this.checkUser();
		this.getUser();
	},
	mounted() {
		this.checkUser();
		this.fetchCurrentProperty();
		jwtService.startTokenExpirationCheck();
	},
	methods: {
		checkUser() {
			const storedType = localStorage.getItem("type");
			if (storedType == "franchise" || storedType == "user_franchise") {
				window.location.href = "/franchise";
			}
			if (storedType == "root" || storedType == "admin") {
				window.location.href = "/mondomicil-admin";
			}
		},
		async fetchCurrentProperty() {
			const storedProperty = localStorage.getItem("currentProperty");
			if (storedProperty) {
				this.property = JSON.parse(storedProperty);
			} else {
				try {
					const response = await fetch(process.env.VUE_APP_API_URL + "logements", { method: "GET", credentials: "include", });
					const data = await response.json();
					if (data.error) {
						window.location.href = "/login";
					} else {
						if (data.length) {
							this.property = data[0];
							localStorage.setItem("currentProperty", JSON.stringify(this.property));
							this.fetchSubscriptionStatus();
						} else {
							if (this.$route.path !== "/ajouter") this.$router.push(`/mes-logements`);
						}
					}
				} catch (error) {
					this.message = "Une erreur est survenue.";
				}
			}
		},
		async fetchSubscriptionStatus() {
			try {
				const currentProperty = JSON.parse(localStorage.getItem('currentProperty'));

				if (currentProperty && currentProperty.stripe_ID) {
					const stripe_ID = currentProperty.stripe_ID;

					const response = await fetch(process.env.VUE_APP_API_URL + 'user/subscription', {
						method: 'POST',
						credentials: "include",
						headers: { 'Content-Type': 'application/json', },
						body: JSON.stringify({ subID: stripe_ID }),
					});

					if (!response.ok) throw new Error('Erreur lors de la récupération de la souscription.');

					const data = await response.json();

					if (data?.status === 'trialing') {
						this.startCountdown(data.trial_end);
					} else if (data?.status === 'active') {
						this.showAlert = false;
						this.clearCountdown();
					} else {
						return this.$router.push(`/mes-logements`);
					}
					console.log(4);
				} else {
					console.error('Aucune propriété sélectionnée ou stripe_ID manquant.');
				}
			} catch (error) {
				console.error('Erreur:', error);
			}
		},
		async getUser() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "user/profil", { method: "GET", credentials: "include", });
				const data = await response.json();
				this.isSubmitting = false;
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.user = data;
				}
			} catch (error) {
				this.message = "Une erreur est survenue lors de l'inscription.";
				this.isSuccess = false;
				this.isSubmitting = false;
			}
		},
		handleSearch(query) {
			this.searchQuery = query;
		},
	},
	watch: {
		$route() {
			this.fetchCurrentProperty();
		},
	},
};
</script>

<style>
#AppPage {
	display: flex;
}

.app-body {
	width: 100%;
	background-color: #f5f5f5;
}

.app-content {
	padding: 0px 50px 50px;
}

@media (max-width: 950px) {
	.app-content {
		padding: 0px 10px 10px;
	}
}
</style>
